import api from '../axiosInstance';
import { ensureCsrfToken } from '../utils/csrfUtils';


// 프로젝트 그룹 목록 조회 요청
export const projectList = async () => {
    //console.log(`[adminApi] 유저 승인 상태 업데이트 API 호출 - userId: ${userId}, status: ${status}`);
  
    // CSRF 토큰을 확인한 후 요청
    await ensureCsrfToken();
    const res = await api.get(`/api/droad/projectgroup/list`, {
    }, {
      //withCredentials: true,
    });
  
    //console.log('[adminApi] 유저 승인 상태 업데이트 응답:', res.data);
    return res;  // 응답 메시지 또는 상태를 리턴
  };

  // 프로젝트 목록 검색 조회 요청
export const projectSearch = async () => {
  //console.log(`[adminApi] 유저 승인 상태 업데이트 API 호출 - userId: ${userId}, status: ${status}`);

  // CSRF 토큰을 확인한 후 요청
  await ensureCsrfToken();
  const res = await api.get(`/api/droad/projectgroup/name`, {
  }, {
    //withCredentials: true,
  });

  //console.log('[adminApi] 유저 승인 상태 업데이트 응답:', res.data);
  return res;  // 응답 메시지 또는 상태를 리턴
};


// 프로젝트 그룹 생성
export const projectGroupUpload = async (groupData) => {
    console.log('프로젝트 그룹 생성 API 호출:', groupData);
  
    // ✅ CSRF 토큰 확인
    await ensureCsrfToken();
  
    try {
      const res = await api.post(
        '/api/droad/projectgroup/upload',
        groupData, // { projectGroupName, projectGroupDesc, projectGroupPassword }
        {
         withCredentials: true, // JWT + CSRF 포함
        }
      );
  
      console.log('프로젝트 그룹 생성 응답:', res.data);
      return res.data; // { status, message } 형태
    } catch (error) {
      console.error('프로젝트 그룹 생성 실패:', error.response?.data || error);
      throw error.response?.data || error;
    }
  };


  // 프로젝트 그룹 삭제 요청
  export const projectGroupDelete = async (id, password) => {
    
    // CSRF 토큰을 확인한 후 요청
    await ensureCsrfToken();
    const res = await api.delete(`/api/droad/projectgroup/delete`,
    {
      withCredentials: true,
      data: { id, password },
    });

     
    return res;  // 응답 메시지 또는 상태를 리턴
  };

 // 프로젝트 생성 및 파일 업로드
 export const projectUpload = async (formData) => {
  await ensureCsrfToken();
  const res = await api.post("/api/droad/project/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    withCredentials: true,
  });
  return res.data;
};

// ✅ 프로젝트 그룹에 해당하는 프로젝트 목록 조회
export const projectLists = async (groupId) => {
  await ensureCsrfToken();
  const res = await api.get("/api/droad/project/list", {
    params: { groupId }, // ✅ 쿼리로 전송
    withCredentials: true,
  });
  return res.data;
};


 //프로젝트 상세 조회
 export const projectInfo = async (projectId) => {
  await ensureCsrfToken();
  const res = await api.get("/api/droad/projectimage/list", {
    params: { projectId }, // ✅ 쿼리로 전송
    withCredentials: true,
  });
  return res.data;
};


 // 프로젝트 삭제 요청
 export const projectDelete = async (projectid) => {
    // CSRF 토큰을 확인한 후 요청
    await ensureCsrfToken();
  const res = await api.delete(`/api/droad/project/delete/${projectid}`,
  {
    withCredentials: true,
  });

  
  return res;  // 응답 메시지 또는 상태를 리턴
};


// 프로젝트 수정 요청
export const projectEdit = async (projectId, projectName = null, projectDescription = null) => {
  // ✅ CSRF 토큰 확인
   await ensureCsrfToken();

  // ✅ 요청 바디 구성
  const payload = {
    projectId,              // 필수
    projectName,            // 선택 (null 가능)
    projectDescription,     // 선택 (null 가능)
  };

  // ✅ API 요청
  const res = await api.put(
    `/api/droad/project/update`,
    payload,                // Request Body
    { withCredentials: true } // 쿠키 포함
  );

  return res; // 응답 반환
};